const adminBaseUrl = `/api/v1/user`;
const authBaseUrl = `/api/v1/auth`;
const commonBaseUrl = `/api/v1/common`;
const finnaceBaseUrl = `/api/v1/finance`;
const doctorBaseUrl = `/api/v1/doctor`;
const doctorAssistantBaseUrl = `/api/v1/doctorAssistant`;
const patientBaseUrl = `/api/v1/patient`;
const reportBaseUrl = `/api/v1/report`;
const bannerBaseUrl = `/api/v1/banner`;
const logBaseUrl = `/api/v1/log`;
const locationBaseUrl = `/api/v1/location`;
const specialtyBaseUrl = `/api/v1/Specialty`;

export const ApiEndpoints = {
  verificationEmail: `${authBaseUrl}/email-verification`,
  resendOTP: `${authBaseUrl}/resend-otp`,
  verifyOTP: `${authBaseUrl}/verify-otp`,
  verifyLogin: `${authBaseUrl}/login`,
  requestResendOtp: `${authBaseUrl}/resend-email-verification`,
  forgotPasswordVerifyEmail: `${authBaseUrl}/forgot-password`,
  resetPassword: `${authBaseUrl}/reset-password`,
  resetTokenValidCheck: `${authBaseUrl}/reset-password-token-valid-check`,
  resetUserRetryCount: (email) =>
    `${authBaseUrl}/reset-retry-count?email=${email}`,
};

export const UserEndPoint = {
  createUser: `${adminBaseUrl}/user`,
  updateUser: `${adminBaseUrl}/user`,
  updateUserStatus: `${adminBaseUrl}/status`,
  updateUserPassword: `${adminBaseUrl}/password`,
  resendPasswordLink: `${adminBaseUrl}/reset-password`,
  getUsers: (page, size, searchText) =>
    `${adminBaseUrl}/users?pageNumber=${page}&pageSize=${size}&searchValue=${searchText}`,
  isUserExisting: (code) =>
    `${adminBaseUrl}/validate-user-existence?UserCode=${code}`,
};

export const DashboardEndPoints = {
  getUsers: `${commonBaseUrl}/doctor-patient-stats`,
  getSpecialization: (id) =>
    `${commonBaseUrl}/doctor-specilization?language=` + id,
  getUserInformation: (email) =>
    `${commonBaseUrl}/user-information?email=` + email,
};

export const ConvenienceFee = {
  route: `${finnaceBaseUrl}/convenience-fee`,
  routetwo: (id) => `${finnaceBaseUrl}/convenience-fee?Id=` + id,
};

export const ProviderEndPoint = {
  getAllActiveProviders: `${finnaceBaseUrl}/providers`,
};

export const DoctorEndPoint = {
  createDoctor: `${doctorBaseUrl}/doctor`,
  updateDoctor: `${doctorBaseUrl}/doctor`,
  getAllDoctors: (page, size, searchText, language) =>
    `${doctorBaseUrl}/doctors?page=${page}&pageSize=${size}&search=${searchText}&language=${language}`,
  searchDoctors: (value) =>
    `${doctorBaseUrl}/doctors?search=${value}&page=1&pageSize=10`,
  getDoctorByID: (id, lang) => `${doctorBaseUrl}/id?id=${id}&language=${lang}`,
  getDoctorFullDetailsByID: (id, lang) =>
    `${doctorBaseUrl}/id-detail?id=${id}&language=${lang}`,
  getLanguages: (lang) => `${doctorBaseUrl}/languages?language=${lang}`,
  getTitles: (lang) => `${doctorBaseUrl}/titles?language=${lang}`,
  verifyDoctorByID: (id) => `${doctorBaseUrl}/verification?id=${id}`,
  ActivationDoctor: `${doctorBaseUrl}/status`,
  featuredDoctor: `${doctorBaseUrl}/featured`,
  resendPasswordLink: `${doctorBaseUrl}/resend-reset-password`,
  blockDoctor: `${doctorBaseUrl}/block`,
};

//patient
export const PatientEndPoint = {
  getAllPatients: (page, size, searchText, language) =>
    `${patientBaseUrl}/patients?page=${page}&pageSize=${size}&search=${searchText}&language=${language}`,
  searchPatients: (value) =>
    `${patientBaseUrl}/patients?search=${value}&page=1&pageSize=10`,
};

//doctor assistant
export const DoctorAssistantEndPoint = {
  createDoctorAssistant: `${doctorAssistantBaseUrl}/doctor-assistant`,
  updateDoctorAssistant: `${doctorAssistantBaseUrl}/doctor-assistent-update`,
  getAllDoctorsAssistant: (page, size, searchText, language) =>
    `${doctorAssistantBaseUrl}/doctor-assistants?page=${page}&pageSize=${size}&search=${searchText}&language=${language}`,
  searchDoctorsAssistant: (value) =>
    `${doctorAssistantBaseUrl}/doctors?search=${value}&page=1&pageSize=10`,
  getDoctorAssistantByID: (id, lang) =>
    `${doctorAssistantBaseUrl}/id?id=${id}&language=${lang}`,
  getDoctorAssistantFullDetailsByID: (id, lang) =>
    `${doctorAssistantBaseUrl}/id-detail?id=${id}&language=${lang}`,
  ActivationDoctorAssistant: `${doctorAssistantBaseUrl}/status`,
  resendPasswordLink: `${doctorAssistantBaseUrl}/resend-reset-password`,
};

// Location
export const LocationEndPoint = {
  ActivationLocation: `${locationBaseUrl}/status`,
  updateLocation: `${locationBaseUrl}/location-update`,
  getLocationByID: (id) => `${locationBaseUrl}/id-locationdetails?id=${id}`,
  GetLocations: (page, pageSize, search, language) =>
    `${locationBaseUrl}/GetLocations?page=${page}&pageSize=${pageSize}&search=${search}&language=${language}`,
  GetDistricts: (provinceId) =>
    `${locationBaseUrl}/districts?provinceId=${provinceId}`,
  GetProvince: () => `${locationBaseUrl}/provinces/`,
  GetCities: (districtId) =>
    `${locationBaseUrl}/cities?districtId=${districtId}`,
  AddLocation: `${locationBaseUrl}/add-Location`,
};

// Specialty
export const SpecialtyEndPoint = {
  GetSpecialties: (page, pageSize, search, language) =>
    `${specialtyBaseUrl}/GetSpecialty?page=${page}&pageSize=${pageSize}&search=${search}&language=${language}`,
  AddSpecialties: `${specialtyBaseUrl}/add-Specialty`,
  getSpecialtyByID: (id) => `${specialtyBaseUrl}/id-specialtydetails?id=${id}`,
  updateSpecialty: `${specialtyBaseUrl}/Specialty-update`,
  deleteSpecialty: `${specialtyBaseUrl}/specialty-delete`,
};

export const TransactionEndPoints = {
  // tax
  addTax: `${finnaceBaseUrl}/tax`,
  getAllTaxes: `${finnaceBaseUrl}/taxes`,
  updateTax: `${finnaceBaseUrl}/tax`,
  removeTax: (id) => `${finnaceBaseUrl}/tax?taxId=` + id,

  // consultation fee
  consultationFee: `${finnaceBaseUrl}/consultation-fee`,
  removeConsultationFee: (id) => `${finnaceBaseUrl}/consultation-fee?Id=` + id,

  // Promo code
  getAllDoctorsAndPromoCodeTypes: `${finnaceBaseUrl}/doctor-promo-code-types`,
  getAllPromoCodes: (pageNumber, pageSize) =>
    `${finnaceBaseUrl}/promo-code?page=${pageNumber}&pageSize=${pageSize}`,
  addPromoCode: `${finnaceBaseUrl}/promo-code`,
  updatePromoCode: (id) => `${finnaceBaseUrl}/promo-code?id=${id}`,
  removePromoCode: (id) => `${finnaceBaseUrl}/promo-code?id=${id}`,

  // Transactions
  getTransactionRelatedData: () => `${finnaceBaseUrl}/transaction-related`,
  getAllTransactions: (
    pageNumber,
    pageSize,
    searchString,
    startDate,
    endDate,
  ) =>
    `${finnaceBaseUrl}/transaction?page=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}&startDate=${startDate}&endDate=${endDate}`,
  getTransactionsByProvider: (
    pageNumber,
    pageSize,
    providerId,
    searchString,
    startDate,
    endDate,
  ) =>
    `${finnaceBaseUrl}/transaction-by-provider?page=${pageNumber}&pageSize=${pageSize}&providerId=${providerId}&searchString=${searchString}&startDate=${startDate}&endDate=${endDate}`,
};

export const LoggerEndPoint = {
  errorLog: (errorText) => `${logBaseUrl}/error?errorText=${errorText}`,
  infoLog: (infoText) => `${logBaseUrl}/info?infoText=${infoText}`,
  warningLog: (warningText) =>
    `${logBaseUrl}/warning?warningText=${warningText}`,
};

//Reports Endpoints
export const ReportEndPoint = {
  getReportDetails: (reportType) =>
    `${reportBaseUrl}/getReportDetails?reportType=${reportType}`,
  exportReport: () => `${reportBaseUrl}/export`,
};

export const PostTransactionReportByFiltersEndPoint = {
  getReportByFilter: () => `${reportBaseUrl}/postTransactionsReportByFilters`,
};

//Filter repord without Column
export const PostFilterReportEndPoint = {
  getReportByFilter: () => `${reportBaseUrl}/postReportsByFilters`,
};

//Banner Endpoints
export const BannerEndPoint = {
  createBanner: `${bannerBaseUrl}/add`,
  getAllBanners: `${bannerBaseUrl}/banners`,
  updatePriority: `${bannerBaseUrl}/update-priority`,
  delete: (id) => `${bannerBaseUrl}/delete?id=${id}`,
  getById: (id) => `${bannerBaseUrl}/get-by-id?id=${id}`,
};
